<template>
  <div class="grid">
    <div class="col-12">

        
            <TabMenu :model="items" />
            
        
      </div>
  </div>
</template>
<script>
export default {
  name: 'AdminNavBar',
  data () {
    return {
      items: [],
    }
  },
  computed: {
    isLoggedIn: function () { return this.$store.state.auth.status.loggedIn }
  },
  mounted() {
    this.items = [
                 {
                    label: 'Dashboard',
                    icon: 'pi pi-fw pi-bolt',
                    to: '/admin',
                },
                {
                    label: 'Users',
                    icon: 'pi pi-fw pi-user',
                    to: '/admin/users',

                },
    ]
  },
  methods: {
  }
}
</script>
<style>

</style>
